import { render } from "./BFrontHeader.vue?vue&type=template&id=9705f294&scoped=true"
import script from "./BFrontHeader.vue?vue&type=script&lang=js"
export * from "./BFrontHeader.vue?vue&type=script&lang=js"

import "./BFrontHeader.vue?vue&type=style&index=0&id=9705f294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9705f294"]])

export default __exports__